import { render } from "./DViewSwitcher.vue?vue&type=template&id=f24596aa&scoped=true"
import script from "./DViewSwitcher.vue?vue&type=script&lang=js"
export * from "./DViewSwitcher.vue?vue&type=script&lang=js"

import "./DViewSwitcher.vue?vue&type=style&index=0&id=f24596aa&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f24596aa"]])

export default __exports__